import { jsx as l } from "react/jsx-runtime";
import * as i from "react";
import { forwardRef as m } from "react";
import { c as b } from "./index-UFb2E87s.js";
import { u as _ } from "./index-DwYXX2sM.js";
import { u as f } from "./index-DuekHEmj.js";
import { P as v } from "./index-BrTLHETv.js";
import { s as k } from "./index-BLPblar-.js";
import { $ as p } from "./utils-CTvPli9r.js";
function F() {
  return k.useSyncExternalStore(
    M,
    () => !0,
    () => !1
  );
}
function M() {
  return () => {
  };
}
var g = "Avatar", [P, Q] = b(g), [$, L] = P(g), h = i.forwardRef(
  (a, e) => {
    const { __scopeAvatar: r, ...o } = a, [n, t] = i.useState("idle");
    return /* @__PURE__ */ l(
      $,
      {
        scope: r,
        imageLoadingStatus: n,
        onImageLoadingStatusChange: t,
        children: /* @__PURE__ */ l(v.span, { ...o, ref: e })
      }
    );
  }
);
h.displayName = g;
var w = "AvatarImage", y = i.forwardRef(
  (a, e) => {
    const { __scopeAvatar: r, src: o, onLoadingStatusChange: n = () => {
    }, ...t } = a, u = L(w, r), s = T(o, t), d = _((c) => {
      n(c), u.onImageLoadingStatusChange(c);
    });
    return f(() => {
      s !== "idle" && d(s);
    }, [s, d]), s === "loaded" ? /* @__PURE__ */ l(v.img, { ...t, ref: e, src: o }) : null;
  }
);
y.displayName = w;
var N = "AvatarFallback", E = i.forwardRef(
  (a, e) => {
    const { __scopeAvatar: r, delayMs: o, ...n } = a, t = L(N, r), [u, s] = i.useState(o === void 0);
    return i.useEffect(() => {
      if (o !== void 0) {
        const d = window.setTimeout(() => s(!0), o);
        return () => window.clearTimeout(d);
      }
    }, [o]), u && t.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ l(v.span, { ...n, ref: e }) : null;
  }
);
E.displayName = N;
function S(a, e) {
  return a ? e ? (a.src !== e && (a.src = e), a.complete && a.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function T(a, { referrerPolicy: e, crossOrigin: r }) {
  const o = F(), n = i.useRef(null), t = o ? (n.current || (n.current = new window.Image()), n.current) : null, [u, s] = i.useState(
    () => S(t, a)
  );
  return f(() => {
    s(S(t, a));
  }, [t, a]), f(() => {
    const d = (C) => () => {
      s(C);
    };
    if (!t) return;
    const c = d("loaded"), A = d("error");
    return t.addEventListener("load", c), t.addEventListener("error", A), e && (t.referrerPolicy = e), typeof r == "string" && (t.crossOrigin = r), () => {
      t.removeEventListener("load", c), t.removeEventListener("error", A);
    };
  }, [t, r, e]), u;
}
var I = h, R = y, x = E;
const j = m(({ className: a, ...e }, r) => /* @__PURE__ */ l(
  I,
  {
    ref: r,
    className: p("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", a),
    ...e
  }
));
j.displayName = I.displayName;
const H = m(({ className: a, ...e }, r) => /* @__PURE__ */ l(R, { ref: r, className: p("aspect-square h-full w-full", a), ...e }));
H.displayName = R.displayName;
const q = m(({ className: a, ...e }, r) => /* @__PURE__ */ l(
  x,
  {
    ref: r,
    className: p("flex h-full w-full items-center justify-center rounded-full bg-muted", a),
    ...e
  }
));
q.displayName = x.displayName;
export {
  j as Avatar,
  q as AvatarFallback,
  H as AvatarImage
};
//# sourceMappingURL=avatar.js.map
